<template>
  <div class="aboutIndexDiv">
    <el-row :gutter="14">
      <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" :offset="2">
        <!-- 本站介绍开始 -->
        <div class="aboutWebSite">
          <h1 style="border-bottom: 1px solid; padding-bottom: 10px;">个人简介</h1>
          <div class="textItem">
            <div class="self-des">
              <span class="span-selfDes"
                >欲善其事，必先利其器。大学几年，我始终坚持天道酬勤的原则，一日三省，自信品格的日趋完善；勇于行事，务实求新，自信工作有所成绩；三更灯火，寒窗苦读，相信学有所成。在校期间，我始终以提高自身的综合素质为目的，以个人的全面发展为奋斗方向，树立正确的人生观和价值观，光荣地加入了中国共产党。</span
              >
              <span class="span-selfDes"
                >为适应社会发展的需求，我努力学好专业知识，多次获得奖学金，较深入、全面地掌握了软件编程、硬件维护与开发、网络应用技术等计算机科学基础理论以及计算机在企业管理、工业生产、辅助设计制造等方面的应用知识，同时注意结合自身专业特点，结合动手实践，先后参与了校新闻网页设计大赛、校程序设计大赛、挑战杯中国大学生创业计划竞赛、校科研立项项目，同时根据自己的爱好，进行了物业管理师的培训及资格认证考核、暑期社会实践调查，都取得了不凡的成绩。</span
              >
            </div>

            <div class="self-image">
              <el-image
                src="https://ts1.cn.mm.bing.net/th/id/R-C.76662531d5ab921d42708b1cfb583a05?rik=9I1FYK5p60Q8NA&riu=http%3a%2f%2fsheencity-bj.oss-cn-hangzhou.aliyuncs.com%2fofficial-site%2fpictures%2f2013-06%2f26%2fbf4d9912f3e0e6325787c276e5075073.jpg&ehk=ZQZ0eJTD0qCchH%2bt1DhMcH72OGYFknH0vGLu%2bxyzSws%3d&risl=&pid=ImgRaw&r=0"
                fit="cover"
                style="width: 100%"
              ></el-image>
            </div>
          </div>
        </div>
        <!-- 本站介绍接收 -->

        <!-- 关于作者开始 -->
        <div class="aboutAuthor">
          <h1 style="border-bottom: 1px solid; padding-bottom: 10px;">关于我</h1>
          <div class="textItem">
            <span class="textTitle">姓名：</span>
            三好学生
          </div>
          <div class="textItem">
            <span class="textTitle">学号：</span><span>202306231558</span>
          </div>

          <div class="textItem">
            <span class="textTitle">邮箱：</span
            ><span>202306231558@qq.com</span>
          </div>

          <div class="textItem">
            <span class="textTitle">爱好：</span><span>学习</span>
          </div>

          <h1 style="border-bottom: 1px solid; padding-bottom: 10px;">喜欢的动漫</h1>
          <div class="works">
            <el-row>
              <el-col
                :xs="20"
                :sm="20"
                :md="10"
                :lg="6"
                :xl="6"
                class="workItem"
              >
                <el-image
                  src="https://pic4.zhimg.com/c380ba809ac2a91f827893f3cc251f7f_r.jpg"
                  fit="cover"
                  class="workImg"
                ></el-image>
                <div class="workName">犬夜叉</div>
              </el-col>

              <el-col
                :xs="20"
                :sm="20"
                :md="10"
                :lg="6"
                :xl="6"
                class="workItem"
              >
                <el-image
                  src="https://pic1.zhimg.com/v2-11a71247ab6be950626a59449d82265c_r.jpg?source=1940ef5c"
                  fit="cover"
                  class="workImg"
                ></el-image>
                <div class="workName">龙珠</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 关于作者结束 -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'AboutIndex',
  data () {
    return {}
  }
}
</script>
<style lang="sss" scoped>
.aboutIndexDiv {
  text-align: left;
}
.workItem {
  height: 200px;
  text-align: center;
}
.workImg {
  height: 128px;
}
.workName {
  margin-block-end: 0px;
}

/* 文本行开始 */
.textItem {
  margin-top: 10px;
  overflow: hidden;
}
.textTitle {
  font-weight: bolder;
}
/* 文本行结束 */

.self-des,
.self-image {
  display: block;
  float: left;
}

.self-des {
  width: 60%;
}

.self-image {
  width: 30%;
  margin-left: 20px;
}
.span-selfDes {
  display: block;
  text-indent: 2em;
  font-size: 18px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/aboutIndex.vue